import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PIPELINE_FEHLER_KATEGORIEN, PipelineFehlerBefund, PipelineFehlerKategorie } from '../../models/test-run.model';

export function istBekannteKategorie(kategorie: string | null | undefined): kategorie is PipelineFehlerKategorie {
  return (PIPELINE_FEHLER_KATEGORIEN as readonly string[]).includes(kategorie ?? '');
}

/**
 * Kategorie, die eine Ergebnis-Spalte statt der Status-Pille zeigt (NEX-1548 AK8): nur fuer eine
 * Runde, die ohne Testergebnisse scheiterte. Testfehler und rote Schritte nach gruenen Tests bleiben
 * aussagekraeftig und behalten die Status-Pille (Entscheidung F1).
 */
export function kategoriePillFuer(befund: PipelineFehlerBefund): PipelineFehlerKategorie | null {
  return befund.aussagekraeftig === false && istBekannteKategorie(befund.fehlerKategorie)
    ? befund.fehlerKategorie
    : null;
}

/** Kategorie eines gescheiterten Pipeline-Laufs (Design `page-ki.jsx:426-436`, `PipeKategoriePill`). */
@Component({
  selector: 'app-pipe-kategorie-pill',
  standalone: true,
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './pipe-kategorie-pill.component.html',
  styleUrl: './pipe-kategorie-pill.component.scss',
})
export class PipeKategoriePillComponent {
  readonly kategorie = input.required<PipelineFehlerKategorie>();
  readonly compact = input(false);
  /** Ohne Angabe gilt nur ein Testfehler als aussagekraeftig; F1 (rote Schritte nach gruenen Tests) setzt true. */
  readonly aussagekraeftig = input<boolean | undefined>(undefined);

  protected readonly bekannt = computed(() => istBekannteKategorie(this.kategorie()));
  protected readonly istAussagekraeftig = computed(() => this.aussagekraeftig() ?? this.kategorie() === 'TESTFEHLER');
}
